<template>
  <v-app>
    <shift-employees-at-place
        :show-dialog="showEpmAtPlace"
        @close="showEpmAtPlace = false"
    />
    <header-row></header-row>
    <v-main app>
      <router-view />
    </v-main>
    <v-footer
        app
        bottom
        fixed
        padless
    >
      <v-card
          class="flex bg-gray text-center"
          flat
          tile
          height="48"
      >
        <v-card-text class="footer-text-color text-subtitle-1">
          {{ fullTitle }} -
          {{ workshopAddress }}  v.{{ vers }}
        </v-card-text>
      </v-card>
    </v-footer>
    <records-panel v-if="showRecordPanel" />
    <connecting-info v-if="true" />
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "App",
  data: () => ({
    connectSuscrib: null,
    vers: process.env.VUE_APP_VERSION,
    showEpmAtPlace: false,
    fullTitle: process.env.VUE_APP_FULL_TITLE,
  }),
  components: {
    shiftEmployeesAtPlace: () => import("/src/components/shift/employeesAtPlace.vue"),
    headerRow: () => import("/src/components/partials/HeaderRow.vue"),
    connectingInfo: () => import("/src/components/partials/connectingInfo.vue"),
    recordsPanel: () => import("/src/components/mainpage/RecordsPanel.vue"),
  },
  computed: {
    ...mapGetters(["login/isAuth", "login/logout"]),
    showRecordPanel () {
      return this.$store.state.login.isAuth && this.$store.state.login.workshop.show_booking_panel
    },
    workshopAddress () {
      return this.$store.state.login.workshop? this.$store.state.login.workshop.address : ''
    },
    ws() {
      return (
        this.$store.state.login.isAuth &&
        sessionStorage.getItem("WSUri") &&
        sessionStorage.getItem("WSToken") &&
        sessionStorage.getItem("WSChannel")
      );
    },
    centrifuge: {
      get () {
        return this.$store.state.login.centrifuge
      },
      set (newVal) {
        this.$store.commit('login/setCentrifuge', newVal)
      }
    },
  },
  created() {
    this.$store.dispatch("information/fetchInformation");
  },
  mounted() {
    if (this.ws) {
      this.centrifugoConnect();
    }
  },
  watch: {
    ws() {
      this.centrifugoConnect();
    },
  },
  methods: {
    centrifugoConnect() {
      this.centrifuge = new this.$centrifuge(sessionStorage.getItem("WSUri"), {
        // sockjs: SockJS,
        // debug: true,
        historyRecover: true,
        pingInterval: process.env.VUE_APP_PING_INTERVAL || 2000,
        pongWaitTimeout: process.env.VUE_APP_PING_WAIT_TIMEOUT || 4000, // установить время ожидания ответа
      });
      this.centrifuge.setToken(sessionStorage.getItem("WSToken"));
      this.centrifuge.connect();
      let self = this;
      let subscription = this.centrifuge.subscribe(
        sessionStorage.getItem("WSChannel"),
        function (message) {
          console.log(message);
          // self.showMessage(message);
        }
      );
      this.centrifuge.on("disconnect",
          () => {
            this.$store.commit('login/setConnectingState', true)
          }
      );
      this.centrifuge.on("connect",
          () => {
            this.$store.commit('login/setConnectingState', false)
          }
      );

      subscription.on("publish",(message) => {
          if (message.data.command == "employeesPresenceCheck") {
            console.log('showEpmAtPlace', this.showEpmAtPlace)
            this.showEpmAtPlace = true
          }
          if (message.data.clientIp == sessionStorage.getItem("WSClientIp") &&  message.data.command && message.data.command == "logout") {
          console.log("hit logout");
          console.log(message.data.clientIp);
          console.log(sessionStorage.getItem("WSClientIp"))
        
        
            self.$store.dispatch("login/logout").then(() => {
              self.$router.push("/login", { force: true });
            });
        
        }
        if (message.data.command && message.data.command == "reloadPage") {
          window.location.reload();
        }
        // console.log("message received: " + message.data.command);
      });
    },
  },
};
</script>

<style>
.footer-text-color {
  color: black!important;
}
.disabled {
  pointer-events: none;
}
.col-xs-1-5,
.col-sm-1-5,
.col-md-1-5,
.col-lg-1-5 {
  position: relative !important;
  min-height: 1px;
  padding-right: 10px;
  padding-left: 10px;
}
@font-face {
  font-family: "PFBeauSanspro-bold";
  src: local("PF Beau Sans Pro Bold"), local("PF-Beau-Sans-Pro-Bold"),
    url("./assets/fonts/PFBeauSansPro-Bold.woff2") format("woff2"),
    url("./assets/fonts/PFBeauSansPro-Bold.woff") format("woff"),
    url("./assets/fonts/PFBeauSansPro-Bold.ttf") format("truetype");
  font-weight: 700;
  font-style: normal;
}

body {
  /*font-family: 'Istok Web', sans-serif;*/
  /*font-weight: 400;*/
}

.col-xs-1-5 {
  width: 20%;
  float: left;
}

.font-normal {
  font-style: normal;
}

.shoulders {
  font-family: "Big Shoulders Display", cursive;
  line-height: 20px;
}

.fs-10 {
  font-size: 10px !important;
}

.fs-12 {
  font-size: 12px !important;
}

.fs-14 {
  font-size: 14px !important;
}

.fs-16 {
  font-size: 16px !important;
}

.fs-18 {
  font-size: 18px !important;
}

.fs-20 {
  font-size: 20px;
}

.w-90 {
  width: 90%;
}

.color-black {
  color: #000;
}

@media (min-width: 0px) {
  .col-sm-1-5 {
    width: 100%;
    float: left;
  }
}

@media (min-width: 576px) {
  .col-sm-1-5 {
    width: 50%;
    float: left;
  }
}

@media (min-width: 768px) {
  .col-sm-1-5 {
    width: 50%;
    float: left;
  }
}

@media (min-width: 992px) {
  .col-md-1-5 {
    width: 25%;
    float: left;
  }
}

@media (min-width: 1200px) {
  .col-lg-1-5 {
    width: 20%;
    float: left;
  }
}

.container {
  margin-top: 20px;
}

.border {
  border: 1px solid black !important;
}

.header-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.middle-container {
  margin-top: 6px;
  height: 110px;
}

.record-margin {
  margin-right: 20px;
  position: relative;
}
.alert-before {
  position: absolute;
  display: none;
  left: 100%;
  z-index: 999;
}
.alert-before.active {
  display: flex;
}
.alert-before-text {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 78px;
  height: 35px;
  background: #d0021b;
  font-weight: normal;
  font-size: 14px;
  line-height: 14px;
  text-align: center;
  color: #ffffff;
}

.record-margin {
  margin-right: 20px;
}

.timeline-container {
  height: 62px;
}

.queue-container {
  margin-top: 16px;
}

.header-time {
  width: 110px;
  height: 37px;
  font-family: "Goblin One", cursive;
  font-size: 30px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}

.header-date {
  width: 58px;
  height: 16px;
  font-family: "Istok Web", sans-serif;
  font-size: 11px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #000000;
}

.header-date-container {
  display: flex;
  justify-content: space-between;
}

.header-time-container {
  margin-left: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.only-sm {
  display: none;
}

.only-pc {
  display: block;
  z-index: 1000;
  position: relative;
  background: #fff;
}
.no-z {
  z-index: 0;
}
@media screen and (max-width: 992px) {
  .only-sm {
    display: block;
  }

  .only-pc {
    display: none;
  }
}

.header-icons-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-icons {
  justify-content: center;
  align-items: center;
  display: flex;
}

.false-icon {
  min-height: 27px;
  min-width: 27px;
  margin: 4px;
  position: relative;
}

.false-icon-image {
  border-radius: 6px;
}

.notification-container {
  position: absolute !important;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 100%;
  left: 100%;
  height: 18px;
  width: 18px;
  border-radius: 50%;
  -webkit-transform: translate(-55%, -55%);
  -moz-transform: translate(-55%, -55%);
  -ms-transform: translate(-55%, -55%);
  -o-transform: translate(-55%, -55%);
  transform: translate(-55%, -55%);
}

.notification-container > span {
  font-size: 13px;
  font-family: "Istok Web", sans-serif;
}

.big-icon-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.false-icon-big {
  display: flex;
  align-items: center;
  justify-content: center;
  /*width: 100%;*/
}

.false-icon-big-image {
  border-radius: 40%;
}

.header-master {
  display: flex;
  justify-content: center;
  align-items: center;
}

.master-icon {
  min-height: 48px;
  min-width: 48px;
  position: relative;
}

.false-icon-master-image {
  border-radius: 50%;
}

.header-contacts {
  margin-left: 10px;
  margin-right: 40%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.master-name {
  font-family: "Istok Web", sans-serif;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  color: #000000;
}

.master-surname {
  font-family: "Istok Web", sans-serif;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  color: #000000;
}

.master-location {
  font-family: "Istok Web", sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: italic;
  line-height: 1.29;
  letter-spacing: normal;
  color: #9b9b9b;
}

.name-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.time-container {
  height: 68px;
  width: 100%;
  justify-content: space-between;
}

.menu-icon {
  font-size: 40px;
  /*margin-right: 40px !important;*/
}

.arrow {
  font-size: 30px;
  text-align: center;
  opacity: 0.3;
}

.record {
  height: 100%;
  background-color: #ffd186;
  margin-right: 8px;
  /*display: flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
}

.record-number-container {
  height: 18px;
  width: 18px;
  background-color: #8d8d8d;
  text-align: center;
  color: white;
  font-family: "Istok Web", sans-serif;
  font-size: 16px;
}

.record-time-text {
  margin-left: 4px;
  font-family: "Istok Web", sans-serif;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.7;
  letter-spacing: normal;
  color: #000000;
}

.record-info {
  margin-left: 5px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.car-text {
  font-family: "Istok Web", sans-serif;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.7;
  letter-spacing: normal;
  color: #4a4a4a;
}

.record-client {
  margin-top: 4px;
  font-family: "Istok Web", sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: italic;
  line-height: 0.88;
  letter-spacing: normal;
  color: #000000;
}

.button-container {
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.button-new-order {
  width: 234px;
  height: 41px;
  border-radius: 27px;
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.5);
  background-image: linear-gradient(to bottom, #f6ffea, #dffac2 50%);
}

.button-new-order > span {
  font-family: "Istok Web", sans-serif;
  font-size: 17px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.06;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
}

.record-time-container {
  display: flex;
  height: 100%;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  align-content: space-around;
  padding: 5px;
}

.record-time {
  font-family: "Big Shoulders Display", cursive;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.7;
  letter-spacing: normal;
  color: #4a4a4a;
}

.record-time-bottom {
  margin-top: 20px;
  font-family: "Big Shoulders Display", cursive;
  font-size: 20px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.7;
  letter-spacing: normal;
  color: #4a4a4a;
}

.car-record-text {
  font-family: "Istok Web", sans-serif;
  font-size: 20px;
  font-weight: bold;
  color: #4a4a4a;
}

.false-car-icon {
  margin-top: 5px;
  min-height: 15px;
  min-width: 15px;
  position: relative;
}

.false-car-image-icon {
  border-radius: 50%;
}

.client-car-name {
  font-family: "Istok Web", sans-serif;
  font-size: 16px;
  font-style: italic;
  letter-spacing: normal;
  color: #000000;
  line-height: 19px;
}

.alarm {
  background: #ec7180;
  color: #fff;
  display: table !important;
  padding: 0 5px;
}
.alarm::before {
  display: inline-block;
  content: "!";
  background: #ec7180;
  font-style: normal;
  margin-right: 3px;
  line-height: inherit;
}

.price-text {
  font-family: "Istok Web", sans-serif;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.88;
  letter-spacing: normal;
  color: #000000;
}

.price-text-1 {
  font-family: "Istok Web", sans-serif;
  font-size: 16px;
  font-weight: bold;
  color: #000000;
}

.counter-block {
  margin-top: 3px;
  width: 22px;
  height: 22px;
  background-color: #4a4a4a;
  display: flex;
  align-items: center;
  justify-content: center;
}

.counter-block > span {
  font-family: "Istok Web", sans-serif;
  font-size: 17px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.82;
  letter-spacing: normal;
  color: #ffffff;
}

.money-container {
  height: 100%;
  display: flex;
  justify-content: space-between !important;
  align-items: flex-end;
  flex-direction: column;
  align-content: space-around;
}

.big-time-text {
  font-family: "Big Shoulders Display", cursive;
  font-size: 35px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.4;
  letter-spacing: normal;
  color: #417505;
}

.arrow-button {
  width: 30px;
  height: 46px;
  border-radius: 7px;
  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
  font-size: 30px;
  text-align: center;
}

.timeline-header {
  border-left: 1px solid black;
  border-right: 1px solid black;
  margin-left: 4px;
  width: 390px;
  height: 18px;
  background-color: #d1d9e4;
  text-align: right;
  font-family: "Istok Web", sans-serif;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #000000;
  padding-right: 5px;
}

.timeline-header-empty {
  border-right: 1px solid black;
  margin-left: 4px;
  width: 390px;
  height: 18px;
  text-align: right;
  font-family: "Istok Web", sans-serif;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  color: #000000;
  padding-right: 5px;
}

.empty-block {
  position: relative;
  height: 24px;
  width: 48.65px;
  border-right: 1px solid #fff;
  border-bottom: 1px solid #fff;
  background-color: #d8d8d8;
}

.timeline-item {
  position: absolute !important;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 0px;
  right: 0px;
  height: 100%;
  width: 18px;
}

.timeline-item-2 {
  position: absolute !important;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 0px;
  right: 6px;
  height: 100%;
  width: 18px;
}

.timeline-item-3 {
  position: absolute !important;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 0px;
  right: 10px;
  height: 100%;
  width: 10px;
}

.bg-yellow {
  background: #f8e71c;
}

.bg-pink {
  background: #f98593;
}

.bg-green {
  background: #a6e263;
}

.bg-blue {
  background: #f1f1f1;
}

.bg-grey {
  background: #f1f1f1;
}

.bg-white {
  background: #ffffff;
}

.bg-orange {
  background: #ffd287;
}

.flex-center-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-end-end {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}

.zero-padding {
  padding: 0 !important;
}

.timeline-head-container {
  position: relative;
  margin-top: 10px;
  height: 90px;
  width: 100%;
  overflow-x: auto;
  background: #fff;
}

.timeline-date-string {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
}

.timeline-first-time-text {
  text-align: right;
  margin-left: 10px;
  font-size: 12px;
  width: 60px;
}

.timeline {
  width: 100%;
  height: 46px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.timeline-button-group {
  margin-left: 20px;
  width: 60px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.timeline-lines-text {
  display: flex;
  flex-direction: column;
}

.timeline-empty-column {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
}

.timeline-black-border {
  border-right: 1px solid black;
}

.flex {
  display: flex;
}

.margin-for-item {
  box-shadow: 0px 0px 7px #ff5757;
}

.dropdown-icon-pointer {
  cursor: pointer;
}

/*OWN STYLES*/
/*header*/
.header_search {
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
  background: #d2d3d7;
  font-style: italic;
  font-weight: normal;
  font-size: 16px;
}

.card-block {
  background: #feedd1;
  padding: 0 15px;
}

.card-block.queued {
  padding: 0;
}
.card-block.queued .block-header {
  padding: 3px 15px !important;
}

.card-block.queued .block-body {
  padding: 1rem 10px 3px 10px !important;
}
.record-margin .delete {
  background: #ffc7ce !important;
}
.record-margin .delete .shoulders:first-child {
  color: #9b9b9b;
  text-decoration: line-through;
}
.taxi {
  box-shadow: 0 0 6px #ffec00 !important;
}
.record-margin .taxi .card-icon {
  display: inline-block !important;
  background-color: #ffee13;
  padding: 0 5px;
  margin: 2px 0;
}
.extra-price .price-text-1 {
  background: #ffee13;
}
.ongoing .standart .shoulders {
  font-style: normal;
  font-weight: bold !important;
  font-size: 20px;
  color: #4a4a4a;
}

.ongoing .standart.tardiness {
  position: relative;
}
.ongoing .standart.tardiness .tard {
  position: absolute;
  top: 0;
  left: 0;
  width: 2%;
  height: 100%;
  background: #d0021b;
  box-shadow: -3px 0 4px #d0021b;
  z-index: 0;
}
.ongoing .standart.tardiness > div {
  z-index: 1;
  margin-left: 2px;
}
.ongoing .standart.tardiness .shoulders:last-child {
  font-weight: bold;
  font-size: 35px;
  color: #417505;
  line-height: 35px;
}
.ongoing .standart.harryup .shoulders:last-child {
  font-weight: bold;
  font-size: 35px;
  color: #f8471c;
  line-height: 35px;
}
.ongoing .standart.tardiness sub {
  bottom: 0.2em;
  font-weight: 300;
  font-size: 20px;
  color: #417505;
  margin-left: -5px;
}
.ongoing .standart.harryup sub {
  bottom: 0.2em;
  font-weight: 300;
  font-size: 20px;
  color: #d0021b;
  margin-left: -5px;
}
.ongoing .harryup .shoulders:last-child {
  text-shadow: 0px 0px 4px #d0021b;
}
.ongoing .harryup .shoulders:last-child sub {
  text-shadow: none;
}
.ongoing .remin .shoulders:last-child {
  display: none;
}
.deferred .remine .shoulders:first-child {
  background: #fffabd;
}
.deferred .remine .conti {
  position: relative;
  z-index: 1;
}
.deferred .remine .conti i {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  height: 100%;
  background: #7ed321;
  z-index: -1;
}
.conti.full {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: #7ed321;
}
.conti.full::after {
  position: absolute;
  content: "✔";
  color: #000;
  z-index: 2;
}
.payed .conti {
  padding: 0 2px;
}
.payed .conti i {
  background: #7ed321;
}
.payed .price-text-1 {
  color: #fff;
}
.payed .shoulders {
  color: #fff;
  background: #e2223a !important;
  padding: 0 3px;
}
.allintime,
.allinout {
  position: absolute;
  top: 0;
  width: 2%;
  height: 100%;
  background: #7ed321;
}
.tme-hour {
  margin-left: 2px;
}
.allinout {
  background: #d0021b;
}
.tard-left {
  left: 0;
}
.tard-right {
  right: 0;
}
.allintime.tard-left {
  box-shadow: -3px 0 4px #7ed321;
}
.allintime.tard-right {
  box-shadow: 2px 0 4px #7ed321;
}
.allinout.tard-left {
  box-shadow: -3px 0 4px #d0021b;
}
.allinout.tard-right {
  box-shadow: 2px 0 4px #d0021b;
}
/*WIDTH*/
.card-block::-webkit-scrollbar {
  width: 5px;
}

/* Track */
.card-block::-webkit-scrollbar-track {
  background: #d3d3d3;
}

/* Handle */
.card-block::-webkit-scrollbar-thumb {
  background: #919191;
}

.card-block h3 {
  font-weight: bold;
  font-size: 20px;
  color: #000000;
}

.header-filter {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 8px;
  box-shadow: 0 2px 1px rgba(0, 0, 0, 0.5);
  border-radius: 9px;
  background: #e9e9e9;
}

.box-sh {
  box-shadow: 0 0 4px #ff5757;
}

.box-sh.bg-blue .alert-own-danger {
  display: flex !important;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(208, 2, 27, 0.5);
  color: #fff;
  z-index: 1;
}

.time-toleft {
  -webkit-box-shadow: 0 0 20px #d0021b;
  -moz-box-shadow: 0 0 20px #d0021b;
  box-shadow: 0 0 20px #d0021b;
}

.alert-own-danger .hour {
  font-weight: bold;
  font-size: 48px;
}

.alert-own-danger .minutes {
  margin-left: 5px;
  bottom: -0.1em;
  font-weight: 300;
  font-size: 30px;
}

.car-color {
  display: flex;
  align-items: center;
  line-height: 14px;
}

.car-color::before {
  content: "";
  position: relative;
  display: inline-block;
  margin-right: 3px;
  width: 17px;
  height: 17px;
  bottom: 2px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}

/*CAR CIRCLE COLORS*/
.car-red::before {
  background: #d0021b;
}

.car-blue::before {
  background: #4a90e2;
}

.car-yellow::before {
  background: #f8e71c;
}

.car-gray::before {
  background: #9b9b9b;
}

.add-block {
  display: flex;
  align-items: center;
  background: #d2d3d7;
  font-style: italic;
  font-size: 16px;
  color: #000000;
  text-align: left;
  padding: 10px;
  margin: 0;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
}

.accomplished {
  background: #eaffd2;
}

.pending {
  background: #E8C2CA;
}

.pending .block-header {
  background: #E8C2CA;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
  margin: 0 -15px;
  padding: 0 !important;
}

.pending .block-header h4 {
  font-weight: bold;
  font-size: 20px;
  color: #000000;
}

.ongoing .block-header {
  background: #ffd185;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
  margin: 0 -15px;
  padding: 0 !important;
}

.ongoing .block-header h4 {
  font-weight: bold;
  font-size: 20px;
  color: #000000;
}

.head-master {
  background: #f6ba57;
  padding: 5px 15px !important;
}

.bg-gray {
  background: #ebecf0 !important;
}

/*TIME TO LEFT */
.time-to-left-alert {
  display: flex;
  align-items: center;
  justify-content: center;
  left: 100%;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
}

.time-to-left-alert span {
  padding: 5px;
  line-height: 14px;
  margin-left: 5px;
  background: #d0021b;
  font-size: 14px;
  color: #fff;
}

.card-block {
  /*overflow-x: hidden;*/
  /*overflow: hidden;*/
}

.block-body {
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  height: 85%;
  z-index: 1;
}

/*SERVICES*/
.services-block {
  /*padding-top: 10px;*/
  overflow: hidden;
}

.acc-block {
  /*padding-top: 10px;*/
  overflow-y: auto;
  overflow-x: hidden;
}

/*WIDTH*/
.services-block::-webkit-scrollbar {
  width: 7px;
}

/* Track */
.services-block::-webkit-scrollbar-track {
  background: #d8d8d8;
}

/* Handle */
.services-block::-webkit-scrollbar-thumb {
  background: #bbbbbb;
}

.false-icon-big h1 {
  font-family: "PFBeauSanspro-bold", sans-serif !important;
  font-size: 58px;
}

.btn-sale-text {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  background: #fb9ea8;
}
.btn-sale-text i {
  color: #fff !important;
  text-align: right;
  text-transform: capitalize;
  font-size: 12px !important;
}

.service-tabs .nav-link {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 30px;
  color: #000;
  line-height: 30px;
}
.brosh-block {
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: space-between;
  min-width: 100px;
  bottom: 100%;
  right: 15px;
  margin-bottom: 5px;
  background: #ffffff;
  border: 1px solid #979797;
  box-sizing: border-box;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  cursor: pointer;
}
.brosh-block:hover {
  background: #fffbcd;
}
.brosh-count-block {
  display: none;
  font-size: 16px;
  line-height: 18px;
  color: #4a4a4a;
  mix-blend-mode: normal;
  opacity: 0.69;
}
.none-brosh {
  display: none;
}
.none-brosh.visible {
  display: inline-block;
  font-size: 16px;
  line-height: 18px;
  color: #4a4a4a;
  mix-blend-mode: normal;
  opacity: 0.69;
}
.brosh-count-block.visible {
  display: inline-block;
}
.brosh-trash {
  display: none;
  width: 25px;
  height: 25px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}
.brosh-trash.visible {
  display: inline-block;
}

.brosh-trash.visible:hover {
  background: #f8e71c;
}
#brush-modal {
  width: 100%;
  font-weight: bold;
  text-align: center;
}
.no,
.yes {
  outline: 0;
  -webkit-box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18),
    0 4px 15px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
  color: #212529;
  font-size: 20px;
  padding: 8px 30px;
}
.no {
  background: #d0021b;
  color: #fff;
}
.yes {
  background: linear-gradient(180deg, #c8fa92 0%, #b5e97c 50%);
}

.cls-4 {
  fill: transparent;
}

#myTab {
  background: #c4c8ce;
  height: 550px;
  overflow-y: auto;
  overflow-x: hidden;
  flex-wrap: nowrap;
}

/*WIDTH*/
#myTab::-webkit-scrollbar {
  width: 10px;
}

/* Track */
#myTab::-webkit-scrollbar-track {
  background: #d8d8d8;
}

/* Handle */
#myTab::-webkit-scrollbar-thumb {
  background: #bbbbbb;
}

#myTab .nav-link.active::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.5);
  z-index: -1;
}

#myTab .nav-link.active {
  width: calc(100% + 5px);
  background: #f5a623;
  color: #000;
}

#myTab .nav-item {
  overflow: visible;
}

#myTab .nav-item .nav-link {
  padding: 0.25rem 1rem;
}

/*ACCORDION*/
.acc-btn button {
  display: block;
  width: 100%;
  background: #ffffff;
  box-shadow: 3px 4px 10px rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  padding: 0.4rem 1.14rem;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}

.acc-btn button .text-part-icon {
  position: relative;
}
.acc-btn button .text-part-icon::before {
  content: "\f105";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  margin-right: 1rem;
  border: 2px solid #000000;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-position: center;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}

.acc-btn button .text-part-icon::after {
  position: absolute;
  bottom: 60%;
  left: 50%;
  width: 20px;
  font-size: 14px;
  height: 20px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #000;
  color: #fff;
  content: attr(data-service);
}

.acc-btn button.active .text-part-icon::before {
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
}

.acc-btn button .text-part {
  font-size: 26px;
  color: #000000;
}

.acc-btn button.active {
  background: #fffbcd;
  box-shadow: 0px -4px 8px rgba(0, 0, 0, 0.5);
}

.acc-btn button .second-part-icons {
  display: none;
}

.acc-btn button.active .second-part-icons {
  display: block;
}

.acc-btn button.active {
  background: #fffbcd;
  box-shadow: 0px -4px 8px rgba(0, 0, 0, 0.5);
}

.acc-btn button.active .first-part-icons {
  display: none;
}
.acc-block {
  display: none;
  width: 100%;
  background: #dae5ef;
  padding: 5px 15px;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}

.reload {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 29px;
  height: 29px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}
/*.reload::after{
    content: url("images/services/car/refresh.png");
    width: 100%;
    height: 100%;
}*/

.reload:hover {
  background: #d0021b;
}

.inner-ab {
  position: absolute;
  z-index: 2;
}

.acc-block.show {
  display: block;
}

.first-part-icons a {
  background: linear-gradient(180deg, #c8fa92 0%, #b5e97c 50%);
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.5);
  border-radius: 11px;
  font-size: 20px;
  color: #4a4a4a;
}

.first-part-icons {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.first-part-icons i {
  font-weight: bold;
  font-size: 22px;
  color: #4a4a4a;
}

.inner-acc {
  background: #e9e9e9 !important;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.5) !important;
  border-radius: 9px !important;
}

.bg-an {
  background: #d8d8d8;
  padding: 15px;
}

.car > img {
  opacity: 0;
}

/*.car {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url("images/services/car/car.png") no-repeat;
    -webkit-background-size: 100% 100%;
    background-size: 100% 100%;

}*/

.car-tires {
  position: absolute;
  z-index: 1;
}

.car-tires-bottom {
  position: absolute;
  z-index: 1;
}

.car-tires::after {
  position: absolute;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  top: -2px;
  left: -2px;
  background: #fff473;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  z-index: -1;
  content: "";
}

.car-tires.active::after {
  display: none;
}

.car-tires-bottom::after {
  display: none;
  position: absolute;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  top: -2px;
  left: -2px;
  background: #fff473;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  z-index: -1;
  content: "";
}

.car-tires-bottom.active::after {
  display: block;
}

/*stock-tire-bantage*/
.stock-tire-bantage {
  padding: 5px;
  background: #e9e9e9;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.5);
  border-radius: 9px;
}

.stock-tire-bantage.active {
  background: #fffbcd;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
}

/*BALANCE TIRES DIAMETER*/
.tire-diameter {
  padding: 10px 20px;
  background: #e9e9e9;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.5);
  border-radius: 9px;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -ms-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
  font-size: 24px;
  color: #000000;
}

.tire-diameter.active {
  background: #fffbcd;
  box-shadow: -2px -1px 3px rgba(0, 0, 0, 0.5);
}

.left-top {
  top: 0;
  left: 0;
  -webkit-transform: translate(-25%, -25%);
  -moz-transform: translate(-25%, -25%);
  -ms-transform: translate(-25%, -25%);
  -o-transform: translate(-25%, -25%);
  transform: translate(-25%, -25%);
}

.right-top {
  top: 0;
  right: 0;
  -webkit-transform: translate(25%, -25%);
  -moz-transform: translate(25%, -25%);
  -ms-transform: translate(25%, -25%);
  -o-transform: translate(25%, -25%);
  transform: translate(25%, -25%);
}

.bottom-left {
  bottom: 0;
  left: 0;
  -webkit-transform: translate(-25%, 25%);
  -moz-transform: translate(-25%, 25%);
  -ms-transform: translate(-25%, 25%);
  -o-transform: translate(-25%, 25%);
  transform: translate(-25%, 25%);
}

.bottom-right {
  bottom: 0;
  right: 0;
  -webkit-transform: translate(25%, 25%);
  -moz-transform: translate(25%, 25%);
  -ms-transform: translate(25%, 25%);
  -o-transform: translate(25%, 25%);
  transform: translate(25%, 25%);
}

.stock {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background: #e9e9e9;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.5);
  border-radius: 9px;
  padding: 3px 0;
}

.stock a {
  font-size: 24px;
  line-height: 18px;
  color: #000000;
  opacity: 1;
  visibility: visible;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}

.stock .stock-tire.active {
  opacity: 0;
  visibility: hidden;
}

.stock-tire-block {
  min-height: 55px;
}

.stock.deactivate {
  opacity: 0;
  visibility: hidden;
}

.services-inner {
  background: #fff;
  -webkit-border-radius: 15px;
  -moz-border-radius: 15px;
  border-radius: 15px;
}

.active-blocks,
.additional-service {
  position: relative;
  background: radial-gradient(100% 100% at 50% 0%, #dae5ef 0%, #b4c5d4 100%);
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}

.active-blocks.active,
.additional-service.active {
  background: #fffbcd;
  box-shadow: none;
}

.deleted {
  text-decoration: line-through;
}

.added-calc {
  font-size: 12px;
  line-height: 15px;
  color: #000000;
}

.after-added {
  display: none;
}

.after-added.active {
  display: block;
}

.price-calc {
  font-size: 14px;
  line-height: 15px;
  color: #000000;
}

.calc-block button {
  background: #ffffff;
  border: 1px solid #b8b8b8;
  box-sizing: border-box;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  width: 23px;
  height: 21px;
  padding: 0;
  font-size: 20px;
  line-height: 22px;
  color: #000000;
}

.calc-block .qnt-calc {
  font-size: 14px;
  line-height: 14px;
  color: #4a4a4a;
}

.additional-service.active .after-added {
  display: inline-block;
}

.calc-block {
  opacity: 0;
  visibility: hidden;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.additional-service.active .calc-block {
  opacity: 1;
  visibility: visible;
}

/*another-types*/
.another-types {
  padding: 10px 5px;
  background: #ebecf0;
  padding-top: 0;
}

.another-types .nav-link {
  background: #ffffff;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  font-style: italic;
  font-size: 16px;
  line-height: 22px;
  color: #000000;
  border: 0;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
  padding: 0.3rem 0.5rem;
}

.another-types .nav-link.active {
  background: #fffbc7;
  box-shadow: none;
}

.another-types .nav-item {
  overflow: visible;
}

.another-types .nav-tabs {
  border-bottom: none;
}

.trash-card {
  width: 30px;
  height: 30px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
}

.trash-card:hover {
  background: #d8d8d8;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.another-types .counter-block {
  background: none;
}

.another-types .new-card .time-toleft {
  background: #f1f1f1;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.another-types .new-card:hover .time-toleft {
  background: #fffbc7;
}

.another-types .tab-pane {
  overflow-y: auto;
  overflow-x: hidden;
}

/*WIDTH*/
.another-types .tab-pane::-webkit-scrollbar {
  width: 5px;
}

/* Track */
.another-types .tab-pane::-webkit-scrollbar-track {
  background: #d8d8d8;
}

/* Handle */
.another-types .tab-pane::-webkit-scrollbar-thumb {
  background: #bbbbbb;
}

/*DISCOUNTS*/
.discount-additional {
  display: none;
  position: absolute;
  top: 5px;
  left: 5px;
  background: none;
  border: none;
}

.additional-service.active .discount-additional {
  display: block;
}

/*refresh*/
.refresh {
  width: 30px;
  height: 30px;
}

/*total*/
.total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #b7d8ff;
  padding: 5px;
}

.discount-percent {
  width: 35px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  background: #97c7ff;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  color: #d0021b;
}

.total del {
  font-size: 22px;
  line-height: 18px;
  color: #4a4a4a;
}

.total .total-price {
  font-size: 40px;
  line-height: 18px;
  color: #4a4a4a;
}

/*CLIENT CARD*/
/*with discount*/
.client-card {
  padding: 15px;
  background: #daffb0;
  box-shadow: 4px 6px 6px rgba(0, 0, 0, 0.5);
  border-radius: 7px;
}

.client-name {
  margin: 0;
  font-size: 28px;
  color: #4a4a4a;
}

.client-phone {
  font-size: 20px;
  color: #4a4a4a;
}

.client-car-info {
  background: #ffffff;
}

.car-name {
  margin: 0;
  font-size: 20px;
  line-height: 18px;
  color: #4a4a4a;
}

.diameter {
  font-size: 26px;
  color: #000000;
}

.discount-count {
  font-size: 28px;
  color: #4a4a4a;
}

.client-discount span {
  font-size: 20px;
  color: #4a4a4a;
  font-style: italic;
}

.car-number {
  font-weight: bold;
  font-size: 20px;
  color: #4a4a4a;
}

.car-number-block {
  padding: 0 5px;
  border: 1px solid #4a4a4a;
  box-sizing: border-box;
  border-radius: 4px;
}

.left-to-discount {
  background: rgba(74, 144, 226, 0.5);
  margin-left: -15px;
  margin-right: -15px;
}

.left-text {
  margin: 0;
  font-size: 16px;
  color: #000000;
}

.left-to-discount-circle {
  position: absolute;
  right: 15px;
  width: 58px;
  height: 58px;
  line-height: 26px;
  background: #7ed321;
}

.discount-count-text {
  font-size: 10px;
  line-height: 0;
  color: #000000;
  text-align: center;
}

.discount-count {
  font-size: 22px;
  line-height: 0;
  color: #000000;
  text-align: center;
}

/*without discount*/
.client-card.without-discount {
  background: #ffc4cb;
}

.without-discount .left-to-discount {
  background: #ffaab4;
}

.without-discount .left-text {
  font-weight: bold;
  font-size: 16px;
  color: #4a4a4a;
}

/*.without-discount .left-to-discount-circle {
    font-family: "Goblin One", sans-serif;
    background: url(images/services/icons/no-discount.png);
    background-repeat: no-repeat;
    -webkit-background-size: 100%;
    background-size: 100%;
    font-size: 28px;
    line-height: 58px;
    color: #FFFFFF;
}*/

/*company discount*/
.client-card.company {
  background: #fff8a6;
}

.company .client-phone {
  color: #4a90e2;
  text-decoration-line: underline;
}

.company .client-discount span {
  font-size: 20px;
  color: #4a4a4a;
  font-style: normal;
}

.company .left-to-discount {
  background: #ffef2f;
}

/*CLIENT ORDER*/
.order-header {
  background: #d8d8d8;
}

.client-order {
  background: #f0f0f0;
  border-radius: 7px;
  /*height: 100%;*/
}

.client-order h5 {
  font-size: 26px;
  color: #000000;
}

.order-footer {
  text-align: right;
  margin-top: -10px;
}

.order-footer .on-work.disabled {
  background: linear-gradient(180deg, #b8b8b8 0%, #d8d8d8 50%);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
  border-radius: 11px;
  font-size: 20px;
  color: #8c8c8c;
  padding-top: 10px;
  padding-bottom: 8px;
}

.order-footer .on-work {
  background: linear-gradient(180deg, #c8fa92 0%, #b5e97c 50%);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
  border-radius: 11px;
  font-size: 20px;
  color: #4a4a4a;
  padding-top: 10px;
  padding-bottom: 8px;
}

.order-footer .on-work.red {
  background: linear-gradient(180deg, #ffdba1 0%, #f5a623 50%);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
  border-radius: 11px;
  font-size: 20px;
  color: #4a4a4a;
  padding-top: 10px;
  padding-bottom: 8px;
}

.put-off {
  display: none;
  background: linear-gradient(180deg, #fff685 0%, #fff142 50%);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
  border-radius: 11px;
  font-size: 20px;
  color: #4a4a4a;
  line-height: 15px;
  padding-top: 10px;
  padding-bottom: 8px;
}

.put-off.enable {
  display: block;
}

.put-off i {
  font-size: 12px;
  color: #9b9b9b;
}
/*todo перекинуть это в тот компонент который эти стили использует*/
.order-body {
  max-height: 500px;
  overflow-x: hidden;
  overflow-y: auto;
}

/*WIDTH*/
.order-body::-webkit-scrollbar {
  width: 5px;
}

/* Track */
.order-body::-webkit-scrollbar-track {
  background: #d8d8d8;
}

/* Handle */
.order-body::-webkit-scrollbar-thumb {
  background: #bbbbbb;
}

/*ORDER BODY*/
.order-name-price {
  display: flex;
  justify-content: space-between;
}

.standart-font-18 {
  font-size: 18px !important;
  color: #000000;
}

.single-order-type {
  font-weight: bold;
  font-size: 14px;
  color: #000000;
}

.type {
  font-style: italic;
  font-size: 14px;
  color: #000000;
  margin: 0;
}

.bonus-alert {
  padding: 5px 25px;
  background: #c2dcfa;
  -webkit-border-radius: 50px 0 50px 50px;
  -moz-border-radius: 50px 0 50px 50px;
  border-radius: 50px 0 50px 50px;
}

.bonus-alert.active {
  display: block;
}

.bonus-alert p {
  text-align: left;
  font-size: 16px;
  color: #4a4a4a;
}

/*ADDITIONAL ORDERS*/
.order-additional {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  font-size: 18px;
  color: #000000;
}

.additional-orders .all-count {
  font-style: italic;
  font-size: 14px;
  color: #000000;
}

.opacity-6 {
  opacity: 0.59;
}

.additional-orders .total-info {
  padding-top: 10px;
  border-top: 2px solid #979797;
}

.disc-info {
  font-size: 18px;
  color: #000000;
}

.left-time {
  font-weight: bold;
  font-size: 18px;
  color: #000000;
}

.additional-bonus-alert {
  padding: 0 15px;
  background: #c2dcfa;
  -webkit-border-radius: 50px 0 50px 50px;
  -moz-border-radius: 50px 0 50px 50px;
  border-radius: 50px 0 50px 50px;
}

.additional-bonus-alert .total-price {
  font-weight: bold;
  font-size: 18px;
  color: #000000;
}

.additional-bonus-alert p {
  font-size: 12px;
  color: #000000;
}

.left-time-small {
  font-weight: bold;
  font-size: 14px;
  color: #000000;
}

.total-end {
  font-size: 14px;
  color: #000000;
  opacity: 0.39;
}

/*PLANING ORDERBOX*/
.planing .order-header {
  background: #fff8a2;
}

.planing-head-info {
  font-size: 18px;
  color: #9b9b9b;
}

.planing-date,
.planing-time {
  font-size: 20px;
  line-height: 18px;
  color: #000000;
}

/*IN WORK*/
.in-work .order-header {
  background: #ffd185;
}

.live-timeline {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  background: linear-gradient(
    0deg,
    rgba(226, 226, 226, 0.979922) 0%,
    #fffdfd 100%
  );
}

.time-start,
.time-end {
  font-family: "Arial", sans-serif;
  font-size: 14px;
  color: #000000;
}

.live-timeline .progress {
  position: relative;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
  height: 34px;
  background: #ffffff;
  box-shadow: inset 0 0 7px rgba(0, 0, 0, 0.5);
}

.live-timeline .progress__cas {
  padding: 0 5px;
}

.live-timeline .progress-bar {
  background: #7fc42f;
}

.live-timeline .progress-info {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-family: "PFBeauSanspro-bold", sans-serif;
  font-weight: 600;
  font-size: 28px;
  color: #000000;
}

.live-timeline .lateness {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  height: 100%;
  background: #d0021b;
  font-family: "PFBeauSanspro-bold", sans-serif;
  font-weight: 600;
  font-size: 28px;
  color: #000000;
}

.live-timeline sub,
.info-lat sub {
  font-size: 18px;
  bottom: -0.05em;
}

.live-timeline .lateness {
  color: #fff;
}

.info-lat {
  display: none;
}

.info-lat.show {
  display: block;
}

.lateness-per {
  display: none;
}

.lateness-per.show {
  display: block;
}

.lateness-ap {
  display: none;
}

.lateness-ap.show {
  display: block;
}

/*ALL SERVICES*/
.add-filters {
  display: none;
}

.add-filters.active {
  display: flex;
}

.add-filters li {
  overflow: visible;
  background: #ffffff;
  border: 1px solid #979797;
}

.add-filters img {
  width: 35px;
}

#allTab a {
  background: #ffffff;
  border: 1px solid #979797;
  box-sizing: border-box;
  font-weight: bold;
  font-size: 20px;
  color: #000000;
  text-align: center;
  box-shadow: 3px 4px 10px rgba(0, 0, 0, 0.5);
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
}

#allTab .nav-item {
  overflow: visible;
}

#allTab a.active {
  background: #fffbc7;
}

/*DISCOUNT MODAL*/
#discountTab .nav-link {
  background: #ffffff;
  border: 1px solid #b8b8b8;
  box-sizing: border-box;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  font-size: 14px;
  color: #727272;
  text-align: center;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
}

#discountTab .nav-link.active {
  background: #fffbcd;
  -webkit-box-shadow: 0;
  -moz-box-shadow: 0;
  box-shadow: 0;
}

.addDiscount {
  background: linear-gradient(180deg, #c8fa92 0%, #b5e97c 50%);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
  border-radius: 11px;
  font-size: 20px;
  color: #4a4a4a;
}

.listing {
  margin: 0;
  margin-bottom: 1em;
  list-style: none;
  font-size: 16px;
  color: #000000;
}

.disck-desck {
  font-size: 16px;
  line-height: 20px;
  color: #000000;
}

.to-vid a {
  font-size: 16px;
  text-decoration-line: underline;
  color: #4a90e2;
}

#addDiscountaddTitle {
  font-size: 26px;
  color: #000000;
}

.personal-disck-header {
  font-weight: bold;
  font-size: 16px;
  color: #000000;
}

.percent-block,
.cash-block {
  position: relative;
  background: #e9e9e9;
  border-radius: 9px;
  padding: 10px 20px;
  width: 40%;
}

.percent-block:after {
  content: "%";
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 14px;
  color: #000000;
}

.cash-block:after {
  content: "₽";
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 14px;
  color: #000000;
}

.percent-block input,
.cash-block input {
  width: 100%;
  text-align: right;
  background: transparent;
  border: none;
  box-shadow: none;
  font-size: 32px;
  color: #000000;
}

.range input {
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  border-top: 3px dashed #979797;
  outline: none;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
}

.range input::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 17px;
  height: 17px;
  background: #f6f6f6;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  cursor: pointer;
}

.range input::-moz-range-thumb {
  width: 17px;
  height: 17px;
  background: #f6f6f6;
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.5);
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  cursor: pointer;
}

.disc-block {
  display: block;
  position: absolute;
  background: #d0021b;
  padding: 10px 1px;
  top: 50%;
  right: -3px;
  writing-mode: vertical-rl;
  color: #ffffff;
  font-weight: bold;
  font-size: 14px;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
}

/*READY*/
.code input {
  background: #e9e9e9;
  border-radius: 9px;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  outline: none;
  font-size: 20px;
  color: #9b9b9b;
  padding: 8px 15px;
  width: 80%;
}

.al {
  font-size: 22px;
  color: #d0021b;
}

.change-cl {
  font-size: 20px;
  text-decoration-line: underline;
  color: #4a90e2;
}

.to-pay {
  font-size: 22px;
  text-align: center;
  color: #000000;
}

.money-text {
  font-size: 18px;
  color: #000000;
}

.checkout-card {
  background: linear-gradient(180deg, #c8fa92 0%, #b5e97c 50%);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
  border-radius: 11px;
  padding: 0.54rem 2.14rem;
  font-size: 12px;
  color: #000000;
}

.pay-method {
  padding: 10px;
  background: #ffffff;
}

.pay-method > div {
  text-align: center;
  padding: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5);
}

.method-text {
  font-size: 22px;
  color: #000000;
}

.method-text img {
  vertical-align: unset;
}

.cash-version-blocks {
  display: none;
}

.cash-version-blocks.active-cash {
  display: block;
}

.money-icons {
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.valute-count {
  position: absolute;
  bottom: 100%;
  font-size: 18px;
  text-align: center;
  color: #000000;
}

.accepted {
  width: 100%;
  background: #e9e9e9;
  border-radius: 9px;
  padding: 10px;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  outline: 0;
  font-size: 24px;
  color: #b8b8b8;
}

.accepted-btn {
  width: 100%;
  padding: 5px;
  background: #e9e9e9;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  border-radius: 9px;
  font-size: 30px;
  color: #4a4a4a;
}

#readyCarousel .carousel-item {
  padding: 20px;
}

#ready-modal .modal-content {
  padding: 20px;
}

.end-title {
  display: none;
}

.ok button {
  padding: 7px 25px;
  background: #d8feaf;
  border: 1px solid #979797;
  font-size: 24px;
  color: #000000;
}

.cash-info i {
  font-size: 18px;
  color: #000000;
}

.cash-info b {
  font-size: 30px;
  color: #4a4a4a;
}

.cash-info span {
  font-size: 22px;
  color: #000000;
}

.cash-info {
  display: none;
}

.cash-info.active {
  display: block;
}

/*issue*/
.issueTitle {
  font-size: 26px;
  color: #000000;
}

.issue-card {
  padding: 5px 25px;
  background: #c2dcfa;
  -webkit-border-radius: 50px 0 50px 50px;
  -moz-border-radius: 50px 0 50px 50px;
  border-radius: 50px 0 50px 50px;
}

.issue-btn {
  background: linear-gradient(180deg, #c8fa92 0%, #b5e97c 50%);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.5);
  border-radius: 11px;
  font-size: 20px;
  line-height: 18px;
  text-align: center;
  color: #4a4a4a;
  padding: 10px 20px;
}

/*ON WORK MODAL*/
.remove-order {
  font-size: 18px;
  line-height: 28px;
  color: #d0021b;
  text-decoration: underline;
}
.on-work-button-title {
  font-weight: bold;
  font-size: 26px;
  color: #000000;
}
/*MEDIA*/
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 650px;
  }

  .modal-sm {
    max-width: 400px;
  }
}

@media (min-width: 1200px) {
  .another-types .tab-pane {
    padding-left: 40px;
    padding-right: 10px;
  }
}

@media (min-width: 1300px) {
  .col-lg-own-3 {
    -ms-flex: 0 0 18.5%;
    flex: 0 0 18.5%;
    max-width: 18.5%;
  }

  .col-lg-own-6 {
    -ms-flex: 0 0 44.5%;
    flex: 0 0 44.5%;
    max-width: 44.5%;
  }

  .col-own-2 {
    -ms-flex: 0 0 21%;
    flex: 0 0 21%;
    max-width: 21%;
  }

  .col-own-lg-2 {
    -ms-flex: 0 0 22%;
    flex: 22%;
    max-width: 22%;
  }
}

@media (min-width: 1570px) {
  .col-own-lg-2 {
    -ms-flex: 0 0 20%;
    flex: 20%;
    max-width: 20%;
  }

  .col-own-7 {
    -ms-flex: 0 0 70%;
    flex: 0 0 70%;
    max-width: 70%;
  }
}

@media (min-width: 1800px) {
  .flex-wrap-no {
    flex-wrap: nowrap;
  }
}

/*MAX*/

@media (max-width: 1764px) {
  .tme-hour span {
    font-size: 15px;
  }

  .car-record-text {
    font-size: 15px;
  }

  #myTab object {
    width: 60px !important;
    height: 60px !important;
  }

  .service-tabs .nav-link {
    font-size: 15px;
    font-weight: bold;
  }

  .acc-btn button .text-part {
    font-size: 19px;
    color: #000000;
  }

  .first-part-icons a {
    font-size: 15px;
  }

  .acc-btn button .text-part::before {
    width: 40px;
    height: 40px;
  }

  .company .client-discount span,
  .car-number,
  .car-name,
  .diameter,
  .total del {
    font-size: 16px;
  }

  .car-tires,
  .car-tires-bottom {
    width: 50px;
    height: 50px;
  }

  .car-tires img,
  .car-tires-bottom img {
    width: 100%;
  }

  .planing-date,
  .planing-time {
    font-size: 14px;
  }

  .client-order h5 {
    font-size: 20px;
  }

  .planing-head-info {
    font-size: 14px;
  }

  .additional-bonus-alert p {
    font-size: 13px;
  }

  .font-normal {
    font-size: 13px !important;
  }
  .alert-own-danger .hour {
    font-weight: bold;
    font-size: 48px !important;
  }
  .order-footer button {
    font-size: 16px !important;
    padding: 0.54rem 1.14rem;
  }

  .total .total-price {
    font-size: 25px;
  }

  .total del,
  .first-part-icons i {
    font-size: 16px !important;
  }
}

@media (max-width: 1690px) {
  .tme-hour span {
    font-size: 18px;
  }

  #myTab .nav-link object {
    width: 70px;
    height: 70px;
  }

  .service-tabs .nav-link {
    font-size: 12px;
    font-weight: bold;
  }
}

@media (max-width: 1650px) {
  .car-color::before {
    width: 15px;
    height: 15px;
  }

  .tire-diameter {
    padding: 10px;
    font-size: 20px;
  }

  element.style {
  }

  .without-discount .left-to-discount-circle {
    font-size: 24px;
    line-height: 50px;
  }

  .left-to-discount-circle {
    width: 50px;
    height: 50px;
  }
  .card-block h3 {
    font-size: 17px;
  }
  .ongoing .block-header h4 {
    font-size: 17px;
  }
}

@media (max-width: 1570px) {
  .card-block h3 {
    font-size: 13px;
  }

  .car-record-text {
    font-size: 10px;
  }

  .client-car-name {
    font-size: 12px;
  }

  .price-text-1 {
    font-size: 10px;
  }

  .add-block {
    font-size: 11px;
  }

  .counter-block {
    width: 32px;
    height: 18px;
  }

  .counter-block > span {
    font-size: 12px;
  }

  .header-filter {
    padding: 3px 5px;
  }

  .header-filter img {
    width: 10px;
  }

  .acc-btn button .text-part {
    font-size: 18px;
  }

  .acc-btn button .text-part::before {
    width: 35px;
    height: 35px;
    background-size: 30%;
  }

  .first-part-icons a {
    font-size: 12px;
    padding: 10px 15px;
  }

  .car-tires {
    width: 50px;
    height: 50px;
  }

  .service-tabs .nav-link {
    /*text-align: center !important;*/
  }

  .service-tabs .nav-link {
    font-size: 13px;
    font-weight: bold;
    padding: 0.3rem 0.3rem;
  }

  .client-name {
    font-size: 23px;
  }

  .disc-info {
    font-size: 15px;
    color: #000000;
  }

  .order-additional {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    font-size: 16px;
    color: #000000;
  }
  .false-icon-big h1 {
    font-size: 55px;
  }
  #myTab {
    max-height: 500px;
  }
}

@media (max-width: 1400px) {
  .car-record-text {
    font-size: 10px;
  }

  .car-tires {
    width: 40px;
    height: 40px;
  }

  #myTab .nav-link object {
    width: 60px;
    height: 60px;
  }

  .another-types .nav-link {
    padding: 0.3rem 0.3rem;
  }

  .service-tabs .nav-link {
    font-size: 12px;
    font-weight: bold;
  }

  .client-name {
    font-size: 20px;
  }

  .company .client-discount span,
  .car-number,
  .car-name,
  .diameter,
  .total del {
    font-size: 12px;
    margin-left: 3px !important;
  }

  .without-discount .left-text {
    font-size: 13px;
  }

  .type {
    font-size: 11px;
  }

  .font-normal {
    font-size: 12px !important;
  }

  .order-footer .on-work {
    padding-top: 7px;
    padding-bottom: 4px;
  }

  .order-footer button {
    font-size: 15px !important;
  }

  .standart-font-18 {
    font-size: 15px !important;
  }

  .acc-btn button .text-part {
    font-size: 16px;
  }

  .car-tires {
    width: 40px;
    height: 40px;
  }

  #myTab object {
    width: 50px !important;
    height: 50px !important;
  }

  .live-timeline .lateness {
    font-size: 20px;
  }

  .total-end {
    margin: 0 0 !important;
  }

  .left-text {
    font-size: 12px;
  }

  .left-to-discount-circle {
    width: 45px;
    height: 45px;
  }

  .left-to-discount-circle {
    line-height: 20px;
  }
  .false-icon-big h1 {
    font-size: 45px;
  }
  #myTab {
    max-height: 450px;
  }
}

@media (max-width: 1360px) {
  .car-color::before {
    width: 13px;
    height: 13px;
  }

  .client-car-name {
    font-size: 10px;
  }
  .another-types .nav-link {
    padding: 0.3rem 0.2rem;
  }
}

@media (max-width: 1300px) {
  .mob-scroll {
    overflow: visible !important;
  }

  .total-end {
    font-size: 12px;
  }

  .bonus-alert p {
    font-size: 12px;
  }

  .acc-btn button .text-part {
    font-size: 13px;
  }

  .additional-bonus-alert p {
    font-size: 11px;
  }

  .single-order-type {
    font-weight: bold;
    font-size: 12px;
    color: #000000;
  }

  .client-order h5 {
    font-size: 17px;
  }

  .additional-bonus-alert .total-price {
    font-weight: bold;
    font-size: 13px;
    color: #000000;
  }

  .service-tabs,
  .services-block,
  .client-block {
    max-width: 100%;
    flex: 0 0 100%;
  }

  .service-tabs,
  .services-block,
  .client-block {
    max-width: 100%;
    flex: 0 0 100%;
  }

  .service-tabs > ul,
  .service-tabs .another-types {
    flex: 0 0 50%;
  }

  .service-tabs {
    display: flex;
  }

  main.overflow-hidden {
    overflow: auto !important;
  }

  .own-wrap {
    flex-wrap: wrap;
  }
}

@media (max-width: 1230px) {
  .car-color::before {
    width: 13px;
    height: 13px;
  }

  .client-car-name {
    font-size: 10px;
  }

  .false-icon-big-image {
    width: 50px;
  }
  .false-icon-big h1 {
    font-size: 35px;
  }
}

@media (max-width: 1200px) {
  .car-tires img {
    width: 35px;
    height: 35px;
  }

  .col-lg-own-3,
  .col-lg-own-6 {
    margin-bottom: 15px;
    padding: 0 15px;
  }
  .ongoing .block-header {
    flex-wrap: wrap;
  }
  .ongoing .block-header {
    flex-wrap: wrap;
  }
  .mob-100 {
    flex: 0 0 100%;
    text-align: center;
  }
  .mob-100:first-child {
    padding: 10px 0;
  }
  .mob-align {
    justify-content: space-between;
  }
}

@media (max-width: 967px) {
  .ongoing .standart .shoulders {
    font-size: 16px;
  }
  .ongoing .standart.tardiness .shoulders:last-child {
    font-size: 30px;
  }
  .ongoing .standart.tardiness sub {
    font-size: 15px;
  }
  .header-filter {
    padding: 3px 3px;
    margin-left: 5px;
  }
  .head-master {
    padding: 5px !important;
  }
}

@media (max-width: 767px) {
  .mob-pa {
    padding-right: 0;
  }
  .tme-hour span {
    font-size: 16px;
  }
  .card-icon img {
    max-width: 15px;
  }
  .ongoing .standart.tardiness .shoulders:last-child {
    font-size: 25px;
  }
  .ongoing .standart.harryup .shoulders:last-child {
    font-size: 30px;
  }
  .ongoing .standart.harryup sub {
    font-size: 14px;
  }
  .ongoing .standart .shoulders {
    font-size: 15px;
  }
  .card-block h3 {
    font-size: 12px;
  }
  .alert-own-danger .hour {
    font-weight: bold;
    font-size: 35px !important;
  }
  .alert-own-danger .minutes {
    font-size: 17px;
  }
}

@media (max-width: 576px) {
  .mob-100-height {
    flex: 0 0 100%;
    width: 100%;
    max-width: 100%;
    max-height: 200px;
    overflow: auto;
  }
  .service-tabs {
    flex-wrap: wrap;
  }
  #myTab,
  .another-types {
    flex: 0 0 100% !important;
    max-height: 200px;
    overflow-y: auto;
  }
}

@media (max-width: 415px) {
  .ongoing .standart.tardiness .shoulders:last-child {
    font-size: 20px;
  }
  .car-color::before {
    width: 9px;
    height: 9px;
  }
  .card-icon img {
    max-width: 10px;
  }
}

/*DELETE THIS STYLE, AFTER CODE REVIEW*/
.client-card {
  display: none;
}

.client-order {
  display: none;
}

.abc {
  bottom: 100%;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
}

.abc .btn {
  background: #fff;
  padding: 10px 15px;
}

.client-card.active {
  display: block;
}

.client-order[data-displ="first"] {
  display: block;
}

.dropdown-menu {
  position: absolute !important;
}
</style>
